import React, { useState,useEffect } from "react";
import {  useNavigate, useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { checkTime } from "../constant/constant";
import IconWithRoundedBorder from "./borderCir/BoderCir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiceD20, faDiceOne, faDiceSix, faDiceThree, faDiceTwo } from "@fortawesome/free-solid-svg-icons";
const MyComponent = () => {
    const { gameName } = useParams(); // Access the dynamic parameter
    const {all_games}=useSelector((state)=>state.users);
    const [Gametypes,setGametypes]=useState([]);
    const navigate=useNavigate();
    useEffect(()=>{
      let validate=false;
      all_games?.map((value)=>{
          if(value?.games_name.split(' ').join('_') === gameName){
              validate=checkTime(value?.open_time);
          }
      })
      if(!validate){
        let data=[
          { href: `/game_type_single/${gameName}/single_digit`, title: "Single Digit",color:'rgb(243, 75, 78)',icon:faDiceOne},
          { href: `/game_type/${gameName}/single_digit`, title: "Single Digit Bulk",color:'rgb(36, 113, 253)',icon:faDiceOne},
          { href: `/game_type_single/${gameName}/single_pana`, title: "Single Pana",color:'rgb(21, 198, 45)',icon:faDiceOne},
          { href: `/game_type/${gameName}/single_pana`, title: "Single Pana Bulk",color:'rgb(6, 177, 220)',icon:faDiceOne},
          { href: `/game_type_single/${gameName}/double_pana`, title: "Double Pana",color:'rgb(132, 25, 215)',icon:faDiceTwo},
          { href: `/game_type/${gameName}/double_pana`, title: "Double Pana Bulk",color:'rgb(54, 85, 252)',icon:faDiceTwo},
          { href: `/game_type_single/${gameName}/triple_pana`, title: "Triple Pana",color:'rgb(254, 118, 0)',icon:faDiceThree},
          // { href: `/game_type/${gameName}/triple_pana`, title: "Triple Pana Bulk",color:'#1ae31a',icon:faDiceOne},
        ]
        setGametypes(data);
      }else{
      let data=[
        { href: `/game_type_single/${gameName}/single_digit`, title: "Single Digit",color:'rgb(243, 75, 78)',icon:faDiceOne},
        { href: `/game_type/${gameName}/single_digit`, title: "Single Digit Bulk",color:'rgb(36, 113, 253)',icon:faDiceOne},
        { href: `/game_type_single/${gameName}/jodi_digit`, title: "Jodi Digit",color:'rgb(36, 113, 253)',icon:faDiceTwo},
        { href: `/game_type/${gameName}/jodi_digit`, title: "Jodi Digit Bulk",color:'rgb(162, 1, 179)',icon:faDiceTwo},
        { href: `/game_type_single/${gameName}/single_pana`, title: "Single Pana",color:'rgb(21, 198, 45)',icon:faDiceOne},
        { href: `/game_type/${gameName}/single_pana`, title: "Single Pana Bulk",color:'rgb(6, 177, 220)',icon:faDiceOne},
        { href: `/game_type_single/${gameName}/double_pana`, title: "Double Pana",color:'rgb(132, 25, 215)',icon:faDiceTwo},
        { href: `/game_type/${gameName}/double_pana`, title: "Double Pana Bulk",color:'rgb(54, 85, 252)',icon:faDiceTwo},
        { href: `/game_type_single/${gameName}/triple_pana`, title: "Triple Pana",color:'rgb(254, 118, 0)',icon:faDiceThree},
        { href: `/game_type/${gameName}/triple_pana`, title: "Triple Pana Bulk",color:'rgb(10, 176, 214)',icon:faDiceThree},
        { href: `/game_type/${gameName}/half_sangam`, title: "Half Sangam",color:'rgb(134, 191, 0)',icon:faDiceD20},
        { href: `/game_type/${gameName}/full_sangam`, title: "Full Sangam",color:'rgb(1, 177, 177)',icon:faDiceSix},
      ]
      setGametypes(data);

      }
  },[]);


  const groupedElements = Gametypes.reduce((acc, item, index) => {
    const groupIndex = Math.floor(index / 2); // Group every 2 items
    if (!acc[groupIndex]) {
      acc[groupIndex] = []; // Initialize a new group
    }
    acc[groupIndex].push(item);
    return acc;
  }, []);
  
  const output = groupedElements.map((group, groupIndex) => (
    <>
    <div className="game_type_box_pre"  key={groupIndex}>
      {group.map((item, index) => (
        <div className="game_type_box" style={{cursor:'pointer'}} onClick={()=>navigate(item.href)}  key={index}>
          <div><IconWithRoundedBorder innerColor={item.color} paddingBox={'11px'} outerColor={item.color} FonCompo={<FontAwesomeIcon
        icon={item.icon}
        size="2x"
        style={{
          color: item.color, // Dots color
          backgroundColor: "white", // Dice border background
          border: "1px solid white", // Dice border color
        }}
      />}/></div>
        <div className="breakLine" style={{border:`1.4px solid ${item.color}`}}>

        </div>
        <p>{item.title}</p> 
          </div>
      ))}
    </div><br/></>
  ));

  return (
    <>
              <div className="all_bids" style={{padding:'3%'}}>{output}</div><br/><br/><br/>
    </>
  );
};

export default MyComponent;
